import { combineReducers } from 'redux'
import interviewRequestsReducer from './interviewRequests'
import calendarStatusReducer from './calendarStatus'
import companyReducer from './company'
import messagesReducer from './messages'
import interviewRequestDetailsReducer from './interviewRequestDetails'

import * as interviewRequestsModule from './interviewRequests'
import * as calendarStatusModule from './calendarStatus'
import * as companyModule from './company'
import * as messagesModule from './messages'

export { interviewRequestsModule, companyModule, calendarStatusModule, messagesModule }

export default combineReducers({
  interviewRequests: interviewRequestsReducer,
  calendarStatus: calendarStatusReducer,
  companies: companyReducer,
  messages: messagesReducer,
  interviewRequestDetails: interviewRequestDetailsReducer,
})
